import { DialogContentText } from "@mui/material";
import { AppDialog } from "@gui/widgets/AppDialog";
import type { ConfirmDialogProps } from "./ConfirmDialog.types";
import { useConfirmDialogViewModel } from "./ConfirmDialog.vm";

/**
 * Asks before an action: a sentence-case question, a short body, Cancel and a confirm button named
 * for the action and coloured by its tone. Use `useConfirm()` to ask from a handler; render this
 * directly only when the dialog has state of its own (a busy confirm button).
 */
export function ConfirmDialog(props: ConfirmDialogProps) {
	const vm = useConfirmDialogViewModel(props);
	return (
		<AppDialog
			open={props.open}
			onClose={props.onCancel}
			size="confirm"
			title={props.title}
			aria-describedby={vm.describedBy}
			cancelLabel={props.cancelLabel}
			closeDisabled={props.busy}
			initialFocus={vm.initialFocus}
			primaryAction={{
				label: props.confirmLabel,
				onClick: props.onConfirm,
				color: vm.confirmColor,
				icon: props.confirmIcon,
				busy: props.busy,
				busyLabel: props.busyLabel,
			}}
			onEnter={props.onEnter}
			onExited={props.onExited}
		>
			{props.body == null ? null : (
				<DialogContentText component="div" id={vm.bodyId}>
					{props.body}
				</DialogContentText>
			)}
		</AppDialog>
	);
}
